<template>
  <v-select
    class="mt-3"
    :clearable="clearable"
    :error-messages="errorMessages"
    :hide-details="hideDetails"
    :items="options"
    :label="label"
    :loading="isLoading"
    :no-data-text="isLoading ? `${$t('loading')}..` : $t('no_results_found')"
    :outlined="outlined"
    :value="normalizedValue"
    @click="loadItems()"
    @input="$emit('input', $event)"
  />
</template>

<script>
export default {
  name: 'ResourceSelect',

  props: {
    clearable: {
      default: false,
      type: Boolean,
    },
    errorMessages: {
      default: () => ([]),
      type: [Array, String],
    },
    hideDetails: {
      default: false,
      type: Boolean,
    },
    label: {
      default: null,
      type: String,
    },
    model: {
      required: true,
      type: Function,
    },
    outlined: {
      default: false,
      type: Boolean,
    },
    value: {
      default: null,
      type: [
        Number,
        String,
      ],
    },
  },

  data () {
    return {
      hasLoaded: false,
      isLoading: false,
      items: null,
    }
  },

  computed: {
    normalizedValue () {
      return Number(this.value)
    },

    options () {
      if (this.items === null) {
        return []
      }

      return this.items
        .all()
        .map((item) => ({
          text: item.data.name,
          value: item.data.id,
        }))
    },
  },

  watch: {
    value () {
      this.loadItems()
    },
  },

  async created () {
    if (!this.value) {
      return
    }

    await this.loadItems()
  },

  methods: {
    async loadItems () {
      if (
        this.hasLoaded ||
        this.isLoading
      ) {
        return
      }

      this.isLoading = true

      try {
        this.items = await this.model
          .request()
          .all()

        this.hasLoaded = true
      } catch (e) {
        this.$notify('error', this.$t('something_unexpected_occurred'))
      } finally {
        this.isLoading = false
      }
    },
  },
}
</script>
